import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/catsat-origenes-recursos';

/**
 * GET CATSAT Origenes Recursos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCATSATOrigenesRecursos = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET CATSAT Origen Recurso
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCATSATOrigenRecurso = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST CATSAT Origen Recurso
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCATSATOrigenRecurso = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH CATSAT Origen Recurso
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCATSATOrigenRecurso = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE CATSAT Origen Recurso
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCATSATOrigenRecurso = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
